import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import ManagerNavbar from "../Layout/ManagerNavbar";
import API_BASE_URL from "../config";

const TeamPage = () => {
  const [myTeam, setMyTeam] = useState([]);
  const [teams, setTeams] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState({ type: "", message: "" });
  const [showForm, setShowForm] = useState(false);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    teamId: "",
    employeeId: "",
    reporterId: "",
    projectId: "",
  });

 const [managerId, setManagerId] = useState(null);

useEffect(() => {
  const id = sessionStorage.getItem("employeeId"); // ✅ use employeeId as managerId
  console.log("Manager ID (from employeeId):", id);
  setManagerId(id);
}, []);


// 🔐 Authentication check
  useEffect(() => {
    const token = sessionStorage.getItem("token"); // or sessionStorage
    if (!token) {
      toast.error("You must be logged in to access this page.");
      navigate("/");
    }
  }, [navigate]);

  // ✅ Fetch all required data on load
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [teamRes, empRes, projRes, myTeamRes] = await Promise.all([
          axios.get(`${API_BASE_URL}/api/teams`),
          axios.get(`${API_BASE_URL}/api/employees/active`),
          axios.get(`${API_BASE_URL}/api/projects`),
          axios.get(`${API_BASE_URL}/api/manageteam/reporter/${managerId}`),
        ]);
        setTeams(teamRes.data);
        setEmployees(empRes.data);
        setProjects(projRes.data);
        setMyTeam(myTeamRes.data);
      } catch (error) {
        console.error("Error loading data:", error);
        setAlert({ type: "danger", message: "Failed to load data." });
      } finally {
        setLoading(false);
      }
    };
    if (managerId) fetchData();
  }, [managerId]);

  // ✅ Handle form input
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // ✅ Submit ManageTeam form
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API_BASE_URL}/api/manageteam`, formData);
      setAlert({ type: "success", message: "Team Member Added successfully!" });
      setFormData({ teamId: "", employeeId: "", reporterId: "", projectId: "" });
      setShowForm(false);

      // Reload team list
      const res = await axios.get(`${API_BASE_URL}/api/manageteam/reporter/${managerId}`);
      setMyTeam(res.data);
    } catch (error) {
      console.error("Error Adding Member:", error);
      setAlert({ type: "danger", message: "Failed to Add Member." });
    }
  };

  // ✅ Remove member
  const handleRemove = async (employeeId) => {
    if (!window.confirm("Are you sure you want to remove this member?")) return;
    try {
      await axios.delete(`${API_BASE_URL}/api/manageteam/${employeeId}`);
      setMyTeam((prev) => prev.filter((emp) => emp.employee.id !== employeeId));
    } catch (err) {
      console.error(err);
      alert("Error removing member.");
    }
  };

  return (
    <>
      <div className="fixed-top">
        <ManagerNavbar />
      </div>
      <div className="container-fluid bg-light vh-100" style={{ paddingTop: "120px", overflowY: "auto" }}>
        <div className="card shadow-sm border-0">
          <div className="card-header bg-light text-dark d-flex justify-content-between align-items-center">
            <h4 className="mb-0">👥 Manage  Team</h4>
            <button className="btn btn-primary btn-sm" onClick={() => setShowForm(!showForm)}>
              {showForm ? "Close Form" : "Add Member"}
            </button>
          </div>

          <div className="card-body bg-light">
            {alert.message && (
              <div className={`alert alert-${alert.type}`} role="alert">
                {alert.message}
              </div>
            )}

            {/* ✅ ManageTeam Form */}
            {showForm && (
              <form onSubmit={handleSubmit} className="p-4 border rounded bg-white mb-4 shadow-sm">
                <div className="row g-3">
                  {/* Team */}
                  <div className="col-md-3">
                    <label className="form-label">Team</label>
                    <select
                      className="form-select"
                      name="teamId"
                      value={formData.teamId}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Team</option>
                      {teams.map((team) => (
                        <option key={team.id} value={team.id}>
                          {team.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Employee */}
                  <div className="col-md-3">
                    <label className="form-label">Employee</label>
                    <select
                      className="form-select"
                      name="employeeId"
                      value={formData.employeeId}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Employee</option>
                      {employees.map((emp) => (
                        <option key={emp.id} value={emp.id}>
                          {emp.firstName} {emp.lastName}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Reporter */}
                  <div className="col-md-3">
                    <label className="form-label">Reporter</label>
                    <select
                      className="form-select"
                      name="reporterId"
                      value={formData.reporterId}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Reporter</option>
                      {employees.map((rep) => (
                        <option key={rep.id} value={rep.id}>
                          {rep.firstName} {rep.lastName}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Project */}
                  <div className="col-md-3">
                    <label className="form-label">Project</label>
                    <select
                      className="form-select"
                      name="projectId"
                      value={formData.projectId}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Project</option>
                      {projects.map((proj) => (
                        <option key={proj.id} value={proj.id}>
                          {proj.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="text-end mt-4">
                  <button type="submit" className="btn btn-primary">
                    <i className="bi bi-check-circle me-2"></i> Save 
                  </button>
                </div>
              </form>
            )}

            {/* ✅ Team List */}
            <h5 className="mb-3 text-dark">Current Teammates</h5>
            {myTeam.length === 0 ? (
              <div className="text-center py-5 text-muted fs-5">No team members yet.</div>
            ) : (
              <div className="table-responsive">
                <table className="table table-hover table-bordered align-middle text-center">
                  <thead className="table-primary">
                    <tr>
                      <th>Sr</th>
                      <th>Employee Name</th>
                      <th>Designation</th>
                      <th>Team</th>
                      <th>Project</th>
                      <th>Manager</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {myTeam.map((assignment, index) => (
                      <tr key={assignment.id}>
                        <td>{index + 1}</td>
                        <td>
                          {assignment.employee.firstName} {assignment.employee.lastName}
                        </td>
                        <td>{assignment.employee.designation}</td>
                        <td>{assignment.team?.name}</td>
                        <td>{assignment.project?.name}</td>
                        <td>
                          {assignment.reporter?.firstName} {assignment.reporter?.lastName}
                        </td>
                        <td>
                          <button
                            className="btn btn-outline-danger btn-sm"
                            onClick={() => handleRemove(assignment.employee.id)}
                          >
                            Remove
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default TeamPage;
